import React, { FC } from 'react';
import { ActivityIndicator, View, StyleSheet } from 'react-native';
import ColorWrapper from '@styles/colors';
import { WithColorProps } from '@styles/colors/types';

interface LoadingProps extends WithColorProps {
  background?: string;
  color?: string;
}

interface SmallLoadingProps {
  color?: string;
}

const Loading: FC<LoadingProps> = ({ C, background, color }) => {
  const bg = background ? background : C('Background / Light / System');
  return (
    <View style={[styles.loadingBox, { backgroundColor: bg }]}>
      <ActivityIndicator size="large" color={color || '#777777'} />
    </View>
  );
};

export const SmallLoading: FC<SmallLoadingProps> = ({ color }) => <ActivityIndicator size="small" color={color ?? '#777777'} />;

export default ColorWrapper(Loading);

const styles = StyleSheet.create({
  loadingBox: {
    flex: 1,
    width: '100%',
    justifyContent: 'center',
    alignContent: 'center',
  },
});
